import Swiper, { Pagination } from 'swiper';
import { $Q } from '../utils/querySelector';
import 'swiper/css';
import { mediaQuery } from '../utils/mediaQuery';

class PhotographerKit {
  constructor() {
    this.photographerKit = $Q('.photographer-kit');

    this.photographerKit && this._init();
  }
  /**
   * Initialize PhotographerKit feature
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */

  _init() {
    mediaQuery(
      '(max-width: 719px)',
      this._initPhotographerKitSlider.bind(this)
    );
  }

  /**
   * Initialize PhotographerKit slider with swiper slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initPhotographerKitSlider() {
    this.slide = new Swiper('.photographer-kit__slider', {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-custom-pagination',
        clickable: true,
      },
    });
  }
}

export { PhotographerKit };
